export const TEST_IDS = {
  // Auth
  LOGIN_EMAIL: "login-email-input",
  LOGIN_PASSWORD: "login-password-input",
  LOGIN_SUBMIT: "login-submit-button",
  LOGIN_FORGOT: "login-forgot-link",
  FORGOT_EMAIL: "forgot-email-input",
  FORGOT_SUBMIT: "forgot-submit-button",

  // Layout
  SIDEBAR: "sidebar-nav",
  SIDEBAR_TOGGLE: "sidebar-toggle-button",
  TOPBAR: "topbar",
  USER_MENU: "user-menu-button",
  LOGOUT_BUTTON: "logout-button",
  NOTIFICATIONS_BELL: "notifications-bell",
  UNREAD_BADGE: "unread-badge",

  // Dashboard
  DASHBOARD: "dashboard-page",
  STAT_TOTAL: "stat-total-active",
  STAT_HIGH: "stat-high-score",
  STAT_CLOSING: "stat-closing-week",
  STAT_VALUE: "stat-total-value",
  PRIORITY_LIST: "priority-list",
  PRIORITY_ITEM: "priority-item",
  LAST_SYNC: "last-sync-info",

  // Radar
  RADAR_PAGE: "radar-page",
  RADAR_SEARCH: "radar-search-input",
  RADAR_DEPT_FILTER: "radar-dept-filter",
  RADAR_SCORE_FILTER: "radar-score-filter",
  RADAR_STATUS_FILTER: "radar-status-filter",
  RADAR_TABLE: "radar-process-table",
  RADAR_ROW: "radar-process-row",
  RADAR_PAGINATION: "radar-pagination",

  // Process detail
  PROCESS_DETAIL: "process-detail-page",
  PROCESS_SCORE_BADGE: "process-score-badge",
  PROCESS_COUNTDOWN: "process-countdown",
  PROCESS_FAVORITE_BTN: "process-favorite-button",
  PROCESS_SOURCE_LINK: "process-source-link",
  PROCESS_AI_ANALYSIS: "process-ai-analysis",

  // Favorites
  FAVORITES_PAGE: "favorites-page",
  FAVORITE_ITEM: "favorite-item",
  FAVORITE_REMOVE: "favorite-remove-button",

  // Alerts
  ALERTS_PAGE: "alerts-page",
  ALERT_ITEM: "alert-item",
  MARK_ALL_READ: "mark-all-read-button",

  // Profile
  PROFILE_PAGE: "profile-page",
  PROFILE_SAVE: "profile-save-button",

  // Admin
  USERS_PAGE: "users-management-page",
  ADD_USER_BTN: "add-user-button",
  USER_ROW: "user-row",

  // Sync
  SYNC_TRIGGER: "sync-trigger-button",
  SYNC_STATUS: "sync-status-indicator",

  // Health
  HEALTH_PAGE: "health-check-page",
  HEALTH_SECOP: "health-secop-status",
  HEALTH_DB: "health-db-status",
  HEALTH_AI: "health-ai-status",
};

// Legacy compat
export const HOME = { emergentLink: "emergent-link" };
